<div class="container-fluid">

  <div class="header-container mt-2">
    <button class="iso-link-button" [ngClass]="{'iso-selected': selectedTab === 'WORKSHOP'}"
            (click)="selectedTab = 'WORKSHOP'">{{
      'bikeshop.plugins.widget.workshop_waivers' | translate}}</button>
    <button [ngClass]="{'iso-selected': selectedTab === 'FITTINGS'}" class="iso-link-button"
            (click)="selectedTab = 'FITTINGS'">{{
      'bikeshop.plugins.widget.fitting_waivers' | translate}}</button>

  </div>

  <div *ngIf="loadingConfig" style="margin-top: 16px;margin-bottom: 16px;display: flex;justify-content: center;">
    <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
    </p-progressSpinner>
  </div>

  <div class="content-container" *ngIf="!loadingConfig">


    <div class="content" *ngIf="selectedTab === 'WORKSHOP'">
      <div class="row margin-top-8">
        <div class="col-md-4 label bold">
          {{'bikeshop.plugins.widget.pre_workshop_waivers' | translate}}
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.enable_pre_service_waiver' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.preServiceWaiverRequired"></p-inputSwitch>
            <small style="
              margin-left: 8px;
              margin-top: auto;
              margin-bottom: auto;">{{'bikeshop.plugins.widget.enable_pre_service_waiver_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.preServiceWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.show_waiver_on_widget' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.preServiceWaiverShowOnWidget"></p-inputSwitch>
            <small style="
              margin-left: 8px;
              margin-top: auto;
              margin-bottom: auto;">{{'bikeshop.plugins.widget.show_waiver_on_widget_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.preServiceWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.pre_service_waiver_terms' | translate}}:
        </div>
        <div class="col-md-8">
          <div>
            <quill-editor [(ngModel)]="waiver.preServiceWaiverTerms" format="html"
            >
            </quill-editor>
          </div>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.preServiceWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.use_additional_field_1' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.preServiceUseAdditionalInfo1"></p-inputSwitch>
            <small style="
          margin-left: 8px;
          margin-top: auto;
          margin-bottom: auto;">{{'bikeshop.plugins.widget.use_additional_field_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8"
           *ngIf="waiver.preServiceWaiverRequired && waiver.preServiceUseAdditionalInfo1">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.additional_field_1_label' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input pInputText [(ngModel)]="waiver.preServiceAdditionalInfo1Label"/>
          </div>
        </div>
        <div class="col-md-4 flex">
          <small style="
        margin-left: 8px;
        margin-top: auto;
        margin-bottom: auto;">{{'bikeshop.plugins.widget.additional_field_label_info' | translate}}
          </small>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.preServiceWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.use_additional_field_2' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.preServiceUseAdditionalInfo2"></p-inputSwitch>
            <small style="
          margin-left: 8px;
          margin-top: auto;
          margin-bottom: auto;">{{'bikeshop.plugins.widget.use_additional_field_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8"
           *ngIf="waiver.preServiceWaiverRequired && waiver.preServiceUseAdditionalInfo2">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.additional_field_2_label' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input pInputText [(ngModel)]="waiver.preServiceAdditionalInfo2Label"/>
          </div>
        </div>
        <div class="col-md-4 flex">
          <small style="
        margin-left: 8px;
        margin-top: auto;
        margin-bottom: auto;">{{'bikeshop.plugins.widget.additional_field_label_info' | translate}}
          </small>
        </div>
      </div>


      <div class="row margin-top-8">
        <div class="col-md-4 label bold">
          {{'bikeshop.plugins.widget.post_workshop_waivers' | translate}}
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.enable_post_service_waiver' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.postServiceWaiverRequired"></p-inputSwitch>
            <small style="
          margin-left: 8px;
          margin-top: auto;
          margin-bottom: auto;">{{'bikeshop.plugins.widget.enable_post_service_waiver_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.postServiceWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.post_service_waiver_terms' | translate}}:
        </div>
        <div class="col-md-8">
          <div>
            <quill-editor [(ngModel)]="waiver.postServiceWaiverTerms" format="html"
            >
            </quill-editor>
          </div>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.postServiceWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.require_technician_signature' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch
              [(ngModel)]="waiver.postServiceWaiverTechnicianSignatureRequired"></p-inputSwitch>
            <small style="
              margin-left: 8px;
              margin-top: auto;
              margin-bottom: auto;
            ">
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.postServiceWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.require_workshop_manager_signature' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch
              [(ngModel)]="waiver.postServiceWaiverWorkShopManagerSignatureRequired"></p-inputSwitch>
            <small style="
              margin-left: 8px;
              margin-top: auto;
              margin-bottom: auto;
            ">
            </small>
          </div>
        </div>
      </div>


      <div class="row margin-top-8" *ngIf="waiver.postServiceWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.use_additional_field_1' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.postServiceUseAdditionalInfo1"></p-inputSwitch>
            <small style="
          margin-left: 8px;
          margin-top: auto;
          margin-bottom: auto;">{{'bikeshop.plugins.widget.use_additional_field_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8"
           *ngIf="waiver.postServiceWaiverRequired && waiver.postServiceUseAdditionalInfo1">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.additional_field_1_label' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input pInputText [(ngModel)]="waiver.postServiceAdditionalInfo1Label"/>
          </div>
        </div>
        <div class="col-md-4 flex">
          <small style="
        margin-left: 8px;
        margin-top: auto;
        margin-bottom: auto;">{{'bikeshop.plugins.widget.additional_field_label_info' | translate}}
          </small>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.postServiceWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.use_additional_field_2' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.postServiceUseAdditionalInfo2"></p-inputSwitch>
            <small style="
          margin-left: 8px;
          margin-top: auto;
          margin-bottom: auto;">{{'bikeshop.plugins.widget.use_additional_field_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8"
           *ngIf="waiver.postServiceWaiverRequired && waiver.postServiceUseAdditionalInfo2">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.additional_field_2_label' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input pInputText [(ngModel)]="waiver.postServiceAdditionalInfo2Label"/>
          </div>
        </div>
        <div class="col-md-4 flex">
          <small style="
        margin-left: 8px;
        margin-top: auto;
        margin-bottom: auto;">{{'bikeshop.plugins.widget.additional_field_label_info' | translate}}
          </small>
        </div>
      </div>
    </div>


    <div class="content" *ngIf="selectedTab === 'FITTINGS'">
      <div class="row margin-top-8">
        <div class="col-md-4 label bold">
          {{'bikeshop.plugins.widget.pre_fitting_waivers' | translate}}
        </div>
      </div>

      <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.enable_pre_fitting_waiver' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.preFittingWaiverRequired"></p-inputSwitch>
            <small style="
          margin-left: 8px;
          margin-top: auto;
          margin-bottom: auto;">{{'bikeshop.plugins.widget.enable_pre_fitting_waiver_info' | translate}}
            </small>
          </div>
        </div>
      </div>

      <div class="row margin-top-8" *ngIf="waiver.preFittingWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.show_waiver_on_widget' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.preFittingWaiverShowOnWidget"></p-inputSwitch>
            <small style="
                  margin-left: 8px;
                  margin-top: auto;
                  margin-bottom: auto;">{{'bikeshop.plugins.widget.show_waiver_on_widget_info' | translate}}
            </small>
          </div>
        </div>
      </div>

      <div class="row margin-top-8" *ngIf="waiver.preFittingWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.pre_fitting_waiver_terms' | translate}}:
        </div>
        <div class="col-md-8">
          <div>
            <quill-editor [(ngModel)]="waiver.preFittingWaiverTerms" format="html"
            >
            </quill-editor>
          </div>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.preFittingWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.use_additional_field_1' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.preFittingUseAdditionalInfo1"></p-inputSwitch>
            <small style="
      margin-left: 8px;
      margin-top: auto;
      margin-bottom: auto;">{{'bikeshop.plugins.widget.use_additional_field_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8"
           *ngIf="waiver.preFittingWaiverRequired && waiver.preFittingUseAdditionalInfo1">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.additional_field_1_label' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input pInputText [(ngModel)]="waiver.preFittingAdditionalInfo1Label"/>
          </div>
        </div>
        <div class="col-md-4 flex">
          <small style="
    margin-left: 8px;
    margin-top: auto;
    margin-bottom: auto;">{{'bikeshop.plugins.widget.additional_field_label_info' | translate}}
          </small>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.preFittingWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.use_additional_field_2' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.preFittingUseAdditionalInfo2"></p-inputSwitch>
            <small style="
      margin-left: 8px;
      margin-top: auto;
      margin-bottom: auto;">{{'bikeshop.plugins.widget.use_additional_field_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8"
           *ngIf="waiver.preFittingWaiverRequired && waiver.preFittingUseAdditionalInfo2">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.additional_field_2_label' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input pInputText [(ngModel)]="waiver.preFittingAdditionalInfo2Label"/>
          </div>
        </div>
        <div class="col-md-4 flex">
          <small style="
    margin-left: 8px;
    margin-top: auto;
    margin-bottom: auto;">{{'bikeshop.plugins.widget.additional_field_label_info' | translate}}
          </small>
        </div>
      </div>


      <div class="row margin-top-8">
        <div class="col-md-4 label bold">
          {{'bikeshop.plugins.widget.post_fitting_waivers' | translate}}
        </div>
      </div>
      <div class="row margin-top-8">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.enable_post_fitting_waiver' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.postFittingWaiverRequired"></p-inputSwitch>
            <small style="
      margin-left: 8px;
      margin-top: auto;
      margin-bottom: auto;">{{'bikeshop.plugins.widget.enable_post_fitting_waiver_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.postFittingWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.post_fitting_waiver_terms' | translate}}:
        </div>
        <div class="col-md-8">
          <div>
            <quill-editor [(ngModel)]="waiver.postFittingWaiverTerms" format="html"
            >
            </quill-editor>
          </div>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.postFittingWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.require_fitter_signature' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.postFittingWaiverFitterSignatureRequired"></p-inputSwitch>
            <small style="
          margin-left: 8px;
          margin-top: auto;
          margin-bottom: auto;
        ">
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.postFittingWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.require_manager_signature' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.postFittingWaiverManagerSignatureRequired"></p-inputSwitch>
            <small style="
          margin-left: 8px;
          margin-top: auto;
          margin-bottom: auto;
        ">
            </small>
          </div>
        </div>
      </div>


      <div class="row margin-top-8" *ngIf="waiver.postFittingWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.use_additional_field_1' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.postFittingUseAdditionalInfo1"></p-inputSwitch>
            <small style="
      margin-left: 8px;
      margin-top: auto;
      margin-bottom: auto;">{{'bikeshop.plugins.widget.use_additional_field_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8"
           *ngIf="waiver.postFittingWaiverRequired && waiver.postFittingUseAdditionalInfo1">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.additional_field_1_label' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input pInputText [(ngModel)]="waiver.postFittingAdditionalInfo1Label"/>
          </div>
        </div>
        <div class="col-md-4 flex">
          <small style="
    margin-left: 8px;
    margin-top: auto;
    margin-bottom: auto;">{{'bikeshop.plugins.widget.additional_field_label_info' | translate}}
          </small>
        </div>
      </div>
      <div class="row margin-top-8" *ngIf="waiver.postFittingWaiverRequired">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.use_additional_field_2' | translate}}:
        </div>
        <div class="col-md-8">
          <div class="p-inputgroup">
            <p-inputSwitch [(ngModel)]="waiver.postFittingUseAdditionalInfo2"></p-inputSwitch>
            <small style="
      margin-left: 8px;
      margin-top: auto;
      margin-bottom: auto;">{{'bikeshop.plugins.widget.use_additional_field_info' | translate}}
            </small>
          </div>
        </div>
      </div>
      <div class="row margin-top-8"
           *ngIf="waiver.postFittingWaiverRequired && waiver.postFittingUseAdditionalInfo2">
        <div class="col-md-4 label">
          {{'bikeshop.plugins.widget.additional_field_2_label' | translate}}:
        </div>
        <div class="col-md-4">
          <div class="p-inputgroup">
            <input pInputText [(ngModel)]="waiver.postFittingAdditionalInfo2Label"/>
          </div>
        </div>
        <div class="col-md-4 flex">
          <small style="
    margin-left: 8px;
    margin-top: auto;
    margin-bottom: auto;">{{'bikeshop.plugins.widget.additional_field_label_info' | translate}}
          </small>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="savingConfig" style="margin-top: 16px;display: flex;justify-content: center;margin-bottom: 128px;">
  <p-progressSpinner [style]="{ width: '30px', height: '30px' }" animationDuration=".5s">
  </p-progressSpinner>
</div>

<div class="row margin-top-16" *ngIf="!loadingConfig && !savingConfig" style="margin-bottom: 128px;">
  <div class="col-md-9"></div>
  <div class="col-md-3">
    <button (click)="updateWaiver()" class="iso-round-button full-width"
            [disabled]="savingConfig">{{'bikeshop.general.save' | translate}}</button>
  </div>
</div>

<p-toast position="bottom-right" styleClass="hubtiger-toast"></p-toast>
